import React from "react";
import CardStandard from "./CardStandard";

const CardsHome = ({ cards }) => {
    return (
        <section className="p-4">
        <div className="container-fluid">
            <div className="row justify-content-center">                
                {cards && cards.map((card, index) => (
                    <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-3 mb-4 mt-lg-5">
                        <div
                            className={`position-relative d-flex cards-home`}
                            key={index}>
                            <CardStandard card={card} />
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </section>
    );
};

export default CardsHome;
